<script setup>
const route = useRoute()

const { data: checkURL } = await useFetch('/api/city/checkurl', { query: { path: route.path } })
if (!(checkURL.value?.status === 'OK')) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Invalid URL(ccode)'
  })
}
// cityInfo
const cityInfo = checkURL.value?.pointInfo

// seo info
const breadCrumbList = checkURL.value?.breadCrumbList

useCustomMetaPoint({ pointName: cityInfo?.cityname, path: route.path, wntouch: true, type: 'point' })
useCustomJsonldPoint({ breadCrumbList })

// save and read history
let showHistory = []
if (import.meta.client) {
  const newHistory = deepCopy({ ...cityInfo, historyKey: cityInfo?.cityname, link: '/clothes' + route.path })
  showHistory = addHistory(newHistory)
}

// cityInfo
// { areacode: 'kanto',
//   areaname: '関東',
//   prefcode: 'chiba',
//   prefname: '千葉',
//   citycode: '12106',
//   cityname: '千葉市美浜区',
//   lat: 35.64039,
//   lon: 140.06314,
//   area: 'chiba' }

// get and prop data
const { data: pinpointData } = await useFetch('/api/clothes/pinpoint', { query: { lat: cityInfo?.lat, lon: cityInfo?.lon, citycode: cityInfo?.citycode } })
const shortData = pinpointData.value?.short || []
const midrangeData = pinpointData.value?.midrange || []
const graphData = pinpointData.value?.graphData || {}
if (graphData?.current) {
  graphData.cityName = cityInfo?.cityname
}
</script>

<template>
  <div>
    <NuxtLayout
      :bread-crumb-list="breadCrumbList"
      ads-key="area"
      name="common"
    >
      <ClothesShortForecast
        :short-data="shortData"
        :city-info="cityInfo"
      />
      <!-- ads-atf のみ、Layout 内部にあるので、個別に記載。(他の広告は layout/common.vue に記載) -->
      <div
        id="2.5web_clothes_atf"
        class="ads-atf"
      />
      <ClothesWeekForecast
        :midrange-data="midrangeData"
        :city-info="cityInfo"
      />
      <ClothesLegend />
      <tempGraph :graph-data="graphData" />
      <ClothesHistory :history-data="showHistory" />
    </NuxtLayout>
  </div>
</template>

<style scoped>
  .ads-atf {
    min-height: 50px;
    margin: 0px auto 10px;
    text-align: center;
    position: relative;
  }
</style>
